import { routes } from 'utils/routing';

interface RewardProductRouteIdentity {
  id: string;
  cmsId?: string | null;
  rewardBenefitId?: string | null;
}

export const getLoyaltyServiceRewardDetailHref = ({
  loyaltyEngineId,
  rewardId,
}: {
  loyaltyEngineId: string;
  rewardId: string;
}) => ({
  pathname: `${routes.loyaltyRewardsList}/${rewardId}`,
  params: { loyaltyEngineId },
});

export const appendRewardProductIdentity = ({
  pathname,
  reward,
}: {
  pathname: string;
  reward: RewardProductRouteIdentity;
}) => {
  const params = new URLSearchParams({ loyaltyEngineId: reward.id });

  if (reward.cmsId) {
    params.set('rewardId', reward.cmsId);
  }
  if (reward.rewardBenefitId) {
    params.set('rewardBenefitId', reward.rewardBenefitId);
  }

  return `${pathname}?${params.toString()}`;
};

export const getLoyaltyServiceRewardProductHref = ({
  menuProductId,
  reward,
}: {
  menuProductId: string;
  reward: RewardProductRouteIdentity;
}) =>
  appendRewardProductIdentity({
    pathname: `${routes.menu}/reward/${menuProductId}`,
    reward,
  });
